import { z } from "zod";

export const InvoiceStatusSchema = z.enum(["Unpaid", "Paid", "Cancelled", "Unposted"]);

export const PurchaseOrderInvoiceLinesSchema = z.object({
  purchaseOrderId: z.string(),
  orderDate: z.string(),
  shipDate: z.string(),
  purchaseOrderStatus: z.string(),
  orderAmount: z.number(),
  shippingFee: z.number(),
  vatRate: z.number().optional(),
  vatAmount: z.number().optional(),
  orderAmountBeforeTax: z.number().optional(),
});

export const PurchaseOrderInvoiceSchema = z.object({
  invoiceId: z.string(),
  invoiceDate: z.string(),
  invoiceAmount: z.number(),
  invoiceStatus: InvoiceStatusSchema,
  poCount: z.number(),
  lastSettleDate: z.string(),
  dueDate: z.string(),
  currencyCode: z.string(),
  invoiceLines: z.array(PurchaseOrderInvoiceLinesSchema),
});

export const PurchaseOrderInvoiceLineDetailsSchema = z.object({
  invoiceId: z.string(),
  invoiceDate: z.string(),
  invoiceStatus: InvoiceStatusSchema,
  shipDate: z.string(),
  purchaseOrderId: z.string(),
  approvedAmount: z.number(),
  quantity: z.number(),
  itemName: z.string(),
  itemNumber: z.string(),
});

export const PurchaseOrderInvoiceResponseSchema = z.object({
  data: z.array(PurchaseOrderInvoiceSchema),
  timestamp: z.string(),
  path: z.string(),
});

export const PurchaseOrderInvoiceLineDetailsResponseSchema = z.object({
  data: z.array(PurchaseOrderInvoiceLineDetailsSchema),
  timestamp: z.string(),
  path: z.string(),
});

export type PurchaseOrderInvoiceResponse = z.infer<typeof PurchaseOrderInvoiceResponseSchema>;

export type PurchaseOrderInvoiceLineDetailsResponse = z.infer<typeof PurchaseOrderInvoiceLineDetailsResponseSchema>;
